import { render, staticRenderFns } from "./BlockAside.vue?vue&type=template&id=69a8fb1d&"
import script from "./BlockAside.vue?vue&type=script&lang=js&"
export * from "./BlockAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports